import React, { useContext } from "react"
import { MdLock } from "react-icons/md"
import { Link } from "react-router-dom"
import { BsFileText } from "react-icons/bs"
import AppContext from "../../../shared/AppContext"

const Card = ({ bundle, setIsUpsellModalOpen, setSelectedBundleTitle }) => {
  const {
    hasAccess,
    name,
    description,
    marketArrayReport,
    insightsReport,
    observatoryReport,
    drilldown,
  } = bundle

  const { trackEvent } = useContext(AppContext)

  const openUpsellModal = (linkClicked) => {
    setIsUpsellModalOpen(true)
    setSelectedBundleTitle(name)

    trackEvent("Observatory bundle upsell modal", {
      path: location.pathname,
      bundle_name: name,
      bundle_report_clicked: linkClicked,
    })
  }

  return (
    <div className="observatory-bundle-card">
      <div className="badge-container">
        {!hasAccess && (
          <div className="locked-flag">
            <MdLock className="icon" />
            <span>Locked</span>
          </div>
        )}
      </div>

      <div className="card">
        <div className="thumbnail-image">
          <img
            src={"/static/images/observatory_bundle_card.png"}
            alt={"Observatory bundle thumbnail"}
          />
        </div>
        <div className="details">
          <div className="title">{name}</div>
          <p className="description">{description}</p>

          <ul className="links">
            {marketArrayReport && (
              <li>
                {hasAccess ? (
                  <Link
                    className="observatory-bundle-item"
                    to={`/market-array/${marketArrayReport.slug}`}
                  >
                    <BsFileText />
                    <p>Observatory Study</p>
                  </Link>
                ) : (
                  <span
                    className="observatory-bundle-item"
                    onClick={() => openUpsellModal("Observatory Study")}
                  >
                    <BsFileText />
                    <p>Observatory Study</p>
                  </span>
                )}
              </li>
            )}
            {insightsReport && (
              <li>
                {hasAccess ? (
                  <Link
                    className="observatory-bundle-item"
                    to={`/marketplace/${insightsReport.slug}`}
                  >
                    <BsFileText />
                    <p>Observatory Feedback Panel</p>
                  </Link>
                ) : (
                  <span
                    className="observatory-bundle-item"
                    onClick={() =>
                      openUpsellModal("Observatory Feedback Panel")
                    }
                  >
                    <BsFileText />
                    <p>Observatory Feedback Panel</p>
                  </span>
                )}
              </li>
            )}
            {observatoryReport && (
              <li>
                {hasAccess ? (
                  <Link
                    className="observatory-bundle-item"
                    to={`/marketplace/${observatoryReport.slug}`}
                  >
                    <BsFileText />
                    <p>Observatory Report</p>
                  </Link>
                ) : (
                  <span
                    className="observatory-bundle-item"
                    onClick={() => openUpsellModal("Observatory Report")}
                  >
                    <BsFileText />
                    <p>Observatory Report</p>
                  </span>
                )}
              </li>
            )}
            {drilldown && (
              <li>
                {hasAccess ? (
                  <Link
                    className="observatory-bundle-item"
                    to={`/research/drill-downs/${drilldown.slug}?back=bundles`}
                  >
                    <BsFileText />
                    <p>Drill Down</p>
                  </Link>
                ) : (
                  <span
                    className="observatory-bundle-item"
                    onClick={() => openUpsellModal("Drilldown")}
                  >
                    <BsFileText />
                    <p>Drill Down</p>
                  </span>
                )}
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Card
